<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('paymentToVendor.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('home'), href: '/' },
				{
					text: $t('paymentToVendor.pageTitle'),
					href: '/admin/payment-vendors'
				},
				{
					text: $t('create'),
					active: true
				}
			]" />
		</div>
		<ts-card>
			<ts-card-wrapper>
				<div class="row">
					<div class="col-md-4">
						<ts-loading-banner :loading="loading">
							<div class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-2 ts-space-y-3">
								<div class="row">
									<div class="col-md-12">
										<label class="required">{{
											$t('paymentToVendor.date')
										}}</label>
										<a-date-picker v-model="model.payment_date" format="DD-MM-YYYY"
											valueFormat="DD-MM-YYYY" class="ts-w-full"></a-date-picker>
										<div class="validate" v-if="errors.has('payment_date')">
											{{ errors.first('payment_date') }}
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<label>{{ $t('paymentToVendor.vendor') }}</label>
										<a-select v-model.number="model.vendor_id" :options="vendorList" class="ts-w-full"
											@change="onVendorChange" showSearch :filterOption="(input, option) =>
												option.componentOptions.children[0].text
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
												"></a-select>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<label>{{ $t('paymentToVendor.grandTotal') }}</label>
										<input v-model="model.invoice_amount" type="text" class="form-control" readonly />
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<label class="required">{{
											$t('paymentToVendor.amountPaid')
										}}</label>
										<input v-model.number="model.amount_paid" type="number" class="form-control" />
										<div class="validate" v-if="errors.has('amount_paid')">
											{{ errors.first('amount_paid') }}
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-6">
										<label class="required">{{
											$t('paymentToVendor.fxRate')
										}}</label>
										<input v-model.number="model.fx_rate" type="number" step="any" class="form-control"
											readonly />
									</div>
									<div class="col-md-6">
										<label :class="allowPick ? 'required' : ''">{{
											$t('paymentToVendor.nextPayment')
										}}</label>
										<a-date-picker v-model="model.next_payment_date" :disabled="!allowPick"
											format="DD-MM-YYYY" valueFormat="DD-MM-YYYY" class="ts-w-full"></a-date-picker>
										<div class="validate" v-if="errors.has('next_payment_date')">
											{{ errors.first('next_payment_date') }}
										</div>
									</div>
								</div>
							</div>
							<div class="row ts-mt-2">
								<div class="col-md-12">
									<PaymentMethod v-model="model" :validate="errors"
										@loading="value => (loading = value)" />
								</div>
							</div>
							<div class="row ts-mt-2">
								<div class="col-md-12">
									<div class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-2 ts-space-y-3">
										<div class="form-group">
											<label>{{ $t('paymentToVendor.remark') }}</label>
											<textarea v-model="model.remarks" rows="3" class="form-control"></textarea>
										</div>
									</div>
								</div>
							</div>
							<br />
							<div class="row">
								<div class="col-md-12 ts-flex ts-space-x-3 ts-justify-end">
									<ts-button @click.prevent="() => $router.push({ name: 'payment-vendor' })
										">{{ $t('cancel') }}</ts-button>
									<ts-button :waiting="waiting" color="primary" @click.prevent="onSave">{{ $t('save')
									}}</ts-button>
								</div>
							</div>
						</ts-loading-banner>
					</div>
					<div class="col-md-8">
						<invoice-detail v-model="model" :validate="errors" ref="invoice" />
					</div>
				</div>
			</ts-card-wrapper>
		</ts-card>
	</div>
</template>
  
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import InvoiceDetail from './components/invoice-detail.vue'
import PaymentMethod from './components/payment-method.vue'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
	name: 'create',
	components: {
		InvoiceDetail,
		PaymentMethod
	},
	data() {
		return {
			waiting: false,
			loading: false,
			src: '',
			errors: new Errors(),
			model: {
				payment_date: moment().format('DD-MM-YYYY'),
				payment_list: [],
				invoice_amount: '',
				fx_rate: '',
				next_payment_date: '',
				remarks: '',
				payment_method_id: 1,
				account_card_no: null,
				account_name: null,
				bank_name: null,
				vendor_id: null,
				card_type: null,
				amount_paid: null
			}
		}
	},
	created() {
		this.model.fx_rate = parseFloat(
			this.$store.state.authUser.sys_setting.fx_rate
		)
		this.loading = true
		this.getVendor().finally(() => (this.loading = false))
	},
	computed: {
		...mapState('supplier/payment', ['vendors']),
		allowPick() {
			if (this.model.vendor_id) {
				return true
			}
			return false
		},
		vendorList() {
			if (this.vendors) {
				return this.vendors.map(el => ({
					value: el.vendor_id,
					label: el.vendor_name
				}))
			}
			return []
		}
	},
	methods: {
		...mapActions('supplier/payment', ['getVendor']),
		amountPaid() {
			this.$refs.invoice.calculationAmountPaid()
			this.model.next_payment_date = null
		},
		onSave() {
			this.waiting = true
			this.src = null
			this.$store
				.dispatch('supplier/payment/store', this.model)
				.then(response => {
					this.$toasted.success(response.message)
					this.$router.push({ name: 'payment-vendor' })
					this.clearInput()
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		onVendorChange() {
			this.model.invoice_amount = ''
			this.model.amount_paid = null
			this.model.amount_due = 0
			this.model.next_payment_date = ''
			this.model.remarks = ''
			this.model.payment_method_id = 1
			this.model.bank_name = null
			this.model.account_card_no = null
			this.model.account_name = null
		},
		clearInput() {
			this.model.payment_date = moment().format('DD-MM-YYYY')
			this.model.payment_list = []
			this.model.next_payment_date = ''
			this.model.remarks = ''
			this.model.payment_method_id = 1
			this.model.vendor_id = null
			this.model.account_card_no = null
			this.model.account_name = null
			this.model.card_type = null
			this.model.bank_name = null
		}
	},
	watch: {
		'model.amount_paid': debounce(function () {
			this.amountPaid()
		}, 500)
	}
}
</script>
  